import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
		padding: spacing.lg,
	},
	title: {
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		textAlign: 'center',
	},
	subtitle: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: 0,
		textAlign: 'center',
	},
	currentCycleCard: {
		background: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.md,
	},
	currentCycleLabel: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		marginBottom: spacing.xs,
	},
	currentCycleValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		fontWeight: 600,
	},
	cycleOption: {
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		padding: spacing.md,
		transition: 'border-color 0.2s, background-color 0.2s',
		':hover': {
			borderColor: colors.border.main,
		},
	},
	cycleOptionSelected: {
		backgroundColor: colors.primary.light,
		borderColor: colors.primary.main,
	},
	cycleOptionTitle: {
		alignItems: 'center',
		display: 'flex',
		fontWeight: 600,
		gap: spacing.sm,
	},
	cycleOptionDescription: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.4,
		marginTop: spacing.xs,
	},
	radioIndicator: {
		alignItems: 'center',
		border: `2px solid ${colors.border.light}`,
		borderRadius: '50%',
		display: 'flex',
		height: 18,
		justifyContent: 'center',
		width: 18,
	},
	radioIndicatorSelected: {
		borderColor: colors.primary.main,
	},
	radioIndicatorDot: {
		backgroundColor: colors.primary.main,
		borderRadius: '50%',
		height: 10,
		width: 10,
	},
	buttonRow: {
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'flex-end',
	},
	blockerBox: {
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		color: colors.danger.main,
		fontSize: typography.fontSizes.xs,
		padding: spacing.md,
	},
	blockerTitle: {
		fontWeight: 600,
		marginBottom: spacing.sm,
	},
	blockerList: {
		listStyle: 'disc',
		margin: `${spacing.sm}px 0 0`,
		paddingLeft: spacing.lg,
	},
	previewMessage: {
		backgroundColor: colors.success.light,
		border: `1px solid ${colors.success.main}`,
		borderRadius: common.borderRadius,
		color: colors.success.dark,
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.5,
		padding: spacing.md,
	},
	previewDetail: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: `${spacing.xs}px 0`,
	},
	previewDetailLabel: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	previewDetailValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.xs,
		fontWeight: 600,
	},
	successContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
		textAlign: 'center',
	},
	successTitle: {
		color: colors.success.dark,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
	},
	successMessage: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		lineHeight: 1.5,
		margin: 0,
	},
	warningItem: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.xs,
	},
	invoiceLink: {
		color: colors.primary.main,
		fontWeight: 600,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	loadingText: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	errorText: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.xs,
	},
	errorMessage: {
		background: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		color: colors.danger.main,
		padding: spacing.md,
		textAlign: 'center',
	},
	noteText: {
		backgroundColor: colors.info.light,
		border: `1px solid ${colors.info.main}`,
		borderRadius: common.borderRadius,
		color: colors.info.dark,
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.5,
		margin: 0,
		padding: spacing.md,
	},
});
